module.exports = __webpack_public_path__ + "img/download-footer.b61f09e9.png";